import { WebUpdateFields } from "../../types/request.types";
import { formatDate } from "../../lib/date-time-formatters";

import classes from "./Request.module.css";

interface WebUpdateProps {
  request: WebUpdateFields;
}

const WebUpdate = ({ request }: WebUpdateProps) => (
  <dl className={classes.details}>
    <dt>Name</dt>
    <dd>{request.name}</dd>
    <dt>Description</dt>
    <dd dangerouslySetInnerHTML={{__html: request.description}}></dd>
    <dt>URL(s)</dt>
    <dd dangerouslySetInnerHTML={{__html: request.urls}}></dd>
    <dt>Requested completion date</dt>
    <dd>
      {request.requested_completion_date && formatDate(request.requested_completion_date)}
    </dd>
  </dl>
);

export default WebUpdate;
